import styled from '@benzinga/themetron';

interface SwitchProps {
  colorOff: string;
  colorOn: string;
  handleToggle: () => void;
  isOn: boolean;
  id?: string;
}

export const Switch: React.FC<SwitchProps> = ({ colorOff, colorOn, handleToggle, id, isOn }) => {
  const inputId = id ?? Math.random();

  return (
    <SwitchWrapper>
      <input checked={isOn} className="switch-checkbox" id={`${inputId}`} onChange={handleToggle} type="checkbox" />
      <label className="switch-label" htmlFor={`${inputId}`} style={{ background: isOn ? colorOn : colorOff }}>
        <span className={`switch-button`} />
      </label>
    </SwitchWrapper>
  );
};

export default Switch;

const SwitchWrapper = styled.div`
  height: 24px;
  position: relative;

  .switch-checkbox {
    height: 0;
    width: 0;
    visibility: hidden;
  }

  .switch-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    width: 50px;
    height: 24px;
    background: grey;
    border-radius: 50px;
    position: relative;
    transition: background-color 0.2s;
    bottom: 24px;
  }

  .switch-label .switch-button {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    width: 20px;
    height: 20px;
    border-radius: 20px;
    transition: 0.2s;
    background: #fff;
    box-shadow: 0 0 2px 0 rgba(10, 10, 10, 0.29);
  }

  .switch-checkbox:checked + .switch-label .switch-button {
    left: calc(100% - 2px);
    transform: translateX(-100%);
  }

  .switch-label:active .switch-button {
    width: 60px;
  }
`;
